import * as types from './types'

export default {
  [types.INIT_DEVICE_DATA](state, data) {
    console.log('init device', data)
    state.device = data
  },
  [types.SET_SEARCH_TERM](state, text) {
    if (text !== undefined && text !== null) {
      state.searchTerm = text
    }
  },
  [types.SET_PAGE_SIZE](state, value) {
    if (value !== undefined && value !== null) {
      state.pageSize = parseInt(value)
    }
  },
  [types.SET_SORT_DIR](state, text) {
    if (text !== undefined && text !== null) {
      state.sortDir = text
    }
  },
  [types.SET_ORDER_BY](state, text) {
    if (text !== undefined && text !== null) {
      state.orderBy = text
    }
  },
  [types.SET_STATUS](state, value) {
    if (value !== undefined && value !== null) {
      state.status = value
    }
  },
  [types.SET_FILTER_BY](state, value) {
    if (value !== undefined && value !== null) {
      state.filterBy = parseInt(value)
    }
  },
  [types.SET_DEVICE](state, data) {
    console.log('SET_DEVICE', data)
    state.device = data
    state.currentDevice = data
  },
  [types.SET_DEVICEFILE](state, data) {
    console.log('SET_DEVICEFILE', data)
    state.deviceFile = data
    state.currentDeviceFile = data
  },
  [types.SET_DEVICES](state, data) {
    state.totalDevices = 0
    state.devices = []
    if (data !== undefined && data !== null) {
      if (data.length > 0) {
        state.totalDevices = data[0].TotalItems
        for (var item of data) {
          item.isChecked = false
        }
        state.devices = data
      }
    }
  },
  [types.SET_DEVICEFILES](state, data) {
    state.totalDeviceFiles = 0
    state.devicefiles = []
    console.log('SET_DEVICE_FILES', data)
    if (data !== undefined && data !== null) {
      if (data.length > 0) {
        state.totalDeviceFiles = data[0].TotalItems
        for (var item of data) {
          item.isChecked = false
        }
        state.deviceFiles = data
        console.log('SET_DEVICE_FILES', state.deviceFiles)
      }
    }
  },
  [types.SET_FOUND_DEVICES](state, data) {
    state.totalFoundDevices = 0
    state.foundDevices = []
    if (data !== undefined && data !== null) {
      if (data.length > 0) {
        state.totalFoundDevices = data[0].TotalItems
        for (var item of data) {
          item.isChecked = false
        }
        state.foundDevices = data
      }
    }
  },
  [types.SET_ASSOCIATED_DEVICES](state, data) {
    state.totalAssociatedFoundDevices = 0
    state.foundAssociatedDevices = []
    if (data !== undefined && data !== null) {
      if (data.length > 0) {
        state.totalAssociatedFoundDevices = data[0].TotalItems
        for (var item of data) {
          item.isChecked = false
        }
        state.foundAssociatedDevices = data
      }
    }
  },
  [types.CLEAR_FOUND_DEVICES](state) {
    state.totalFoundDevices = 0
    state.foundDevices = []
  },
  [types.CLEAR_DEVICES](state) {
    state.totalDevices = 0
    state.devices = []
  },
  [types.SET_TOOLS](state, data) {
    state.totalTools = 0
    state.tools = []
    if (data !== undefined && data !== null) {
      if (data.length > 0) {
        state.totalTools = data[0].TotalItems
        for (var item of data) {
          item.isChecked = false
        }
        state.tools = data
      }
    }
  },
  [types.SET_ACTIVE_TAB](state, tab) {
    state.activeTab = tab
  },
  [types.SET_TOOL_MAKES](state, data) {
    state.toolMakes = []
    if (data !== undefined && data !== null) {
      if (data !== '') {
        state.toolMakes = data
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/devices/mutations.js